
const funding = () => import ('@/pages/account/funding.vue')
const circle = () => import ('@/pages/account/circle/circle.vue')
const recommend = () => import ('@/pages/account/circle/recommend/recommend.vue')
const payfee  = () => import ('@/pages/account/payfee/payfee')
const binding  = () => import ('@/pages/account/binding/binding')
const add  = () => import ('@/pages/account/binding/binding-add')
export default [
    {
        path: 'account/funding',
        name:'account/funding',
        component: funding
    },
    {
        path: 'account/circle',
        name:'account/circle',
        component: circle
    },
    {
        path: 'account/circle/recommend',
        name:'account/circle/recommend',
        component: recommend
    },
    {
        path: 'account/payfee',
        name:'account/payfee',
        component: payfee
    },
    {
        path: 'account/binding',
        name:'account/binding',
        component: binding
    },
    {
        path: 'account/add',
        name:'account/add',
        component: add
    }
]


// WEBPACK FOOTER //
// ./src/router/account.js